// src/tiptap/chunkAttribute.js
import { Extension } from '@tiptap/core';

export const ChunkAttribute = Extension.create({
  name: 'chunkAttribute',

  addGlobalAttributes() {
    return [
      {
        types: [
          'paragraph',
          'heading',
          'bulletList',
          'orderedList',
          'codeBlock',
          'blockquote',
          'horizontalRule'
        ],
        attributes: {
          chunk: {
            default: null,
            parseHTML: element => element.getAttribute('data-chunk'),
            renderHTML: attributes => {
              if (!attributes.chunk) return {};
              return {
                'data-chunk': attributes.chunk,
              };
            },
          },
        },
      },
    ];
  },
});
